import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Spin } from "antd";

const Success = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const shouldDispatch = localStorage.getItem("shouldDispatch");
    if (shouldDispatch === "true") {
      dispatch({ type: "RESET_WITHOUT_QUESTIONS" });
      localStorage.removeItem("shouldDispatch"); // Clean up
    }
    window.location.href = "https://utirx.com/thank-you/"
  }, [dispatch]);

  return (
    <div className="success">
      <Spin size="large" tip="Redirecting..." />
      {/* <Result
        status="success"
        title="Your request was successfully submitted!"
        subTitle={
          "Your request for UTI treatment has been sent to our providers for review. You will receive an email with a confirmation of your request as well as a payment receipt. "
        }
        extra={[
          <p>
            If your case is approved, you will receive an email with
            instructions to pick up your prescription at the pharmacy.
          </p>,
          <p>
            A confirmation email and receipt will be sent to the email you
            provided. Please also check your junk mail folder.
          </p>,
          <p
            style={{ color: "rgba(0,0,0)" }}
          >{`Here is your confirmation ID:  ${apiRequest?.payment?.id}`}</p>,
          <Button type="primary" onClick={() => goBack()}>
            Go to Homepage
          </Button>,
        ]}
      /> */}
    </div>
  );
};

export default Success;
